export { default } from "./RichTextTable";
